/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Most_PopularInputs */

const en_pricing_most_popular = /** @type {(inputs: Pricing_Most_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most Popular`)
};

const es_pricing_most_popular = /** @type {(inputs: Pricing_Most_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más popular`)
};

const fr_pricing_most_popular = /** @type {(inputs: Pricing_Most_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le plus populaire`)
};

const de_pricing_most_popular = /** @type {(inputs: Pricing_Most_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am beliebtesten`)
};

const ja_pricing_most_popular = /** @type {(inputs: Pricing_Most_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一番人気`)
};

const zh_pricing_most_popular = /** @type {(inputs: Pricing_Most_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最受欢迎`)
};

const ar_pricing_most_popular = /** @type {(inputs: Pricing_Most_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأكثر شيوعاً`)
};

const id_pricing_most_popular = /** @type {(inputs: Pricing_Most_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paling Populer`)
};

const it_pricing_most_popular = /** @type {(inputs: Pricing_Most_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più Popolare`)
};

const ru_pricing_most_popular = /** @type {(inputs: Pricing_Most_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Популярный`)
};

const pt_pricing_most_popular = /** @type {(inputs: Pricing_Most_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais Popular`)
};

const ko_pricing_most_popular = /** @type {(inputs: Pricing_Most_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가장 인기 있는`)
};

/**
* | output |
* | --- |
* | "Most Popular" |
*
* @param {Pricing_Most_PopularInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_most_popular = /** @type {((inputs?: Pricing_Most_PopularInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Most_PopularInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_most_popular(inputs)
	if (locale === "es") return es_pricing_most_popular(inputs)
	if (locale === "fr") return fr_pricing_most_popular(inputs)
	if (locale === "de") return de_pricing_most_popular(inputs)
	if (locale === "ja") return ja_pricing_most_popular(inputs)
	if (locale === "zh") return zh_pricing_most_popular(inputs)
	if (locale === "ar") return ar_pricing_most_popular(inputs)
	if (locale === "id") return id_pricing_most_popular(inputs)
	if (locale === "it") return it_pricing_most_popular(inputs)
	if (locale === "ru") return ru_pricing_most_popular(inputs)
	if (locale === "pt") return pt_pricing_most_popular(inputs)
	return ko_pricing_most_popular(inputs)
});